import React from "react";
import styles from "./TextFieldsLine.module.css"
import {TextField} from "../textField/TextField";

interface TextFieldProps {
    leftFieldTitle: string
    leftFieldValue: any
    rightFieldTitle: string
    rightFieldValue: any
}

export const TextFieldsLine: React.FC<TextFieldProps> = ({
                                                             leftFieldTitle,
                                                             leftFieldValue,
                                                             rightFieldTitle,
                                                             rightFieldValue
                                                         }) => {
    return <div className={styles.wrapper}>
        <TextField title={leftFieldTitle} value={leftFieldValue}/>
        <TextField title={rightFieldTitle} value={rightFieldValue}/>
    </div>
}
